import Model from '@ember-data/model';
import { Type } from '@warp-drive/core-types/symbols';

export default class ParityManagerStat extends Model {
  [Type] = 'parity-manager/stat' as const;
}
